import { render, staticRenderFns } from "./ImportTimetable.vue?vue&type=template&id=31c47b37&scoped=true"
import script from "./ImportTimetable.vue?vue&type=script&lang=js"
export * from "./ImportTimetable.vue?vue&type=script&lang=js"
import style0 from "./ImportTimetable.vue?vue&type=style&index=0&id=31c47b37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c47b37",
  null
  
)

export default component.exports